import type { IIconsVector } from 'shared/ui/Icon'
import icons from 'shared/ui/Icon/icons'

export const isIconKey = (key: string): key is IIconsVector => {
  return key in icons
}
